const SET_ACTIVE_COURSE_RUN = 'SET_ACTIVE_COURSE_RUN';

export default SET_ACTIVE_COURSE_RUN;
